import * as React from 'react'
import Rating from 'react-rating'

import starEmptySvg from '@/assets/icons/star/empty.svg'
import starFullSvg from '@/assets/icons/star/full.svg'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'
import formatLocaleNumber from '@/utils/numbers/formatLocaleNumber'
import roundToNDecimal from '@/utils/numbers/roundToNDecimals'

import style from './ProductCard.module.scss'

export default memo<{
  rating: number
  ratingCount: number
}>(function ProductRating({rating, ratingCount}) {
  const roundedRating = roundToNDecimal(rating, 1)

  if (!rating) return null

  return (
    <div className={style.ProductRating}>
      <span aria-hidden>{roundedRating}</span>
      <span className={style.ProductRatingStars} aria-hidden>
        <div aria-hidden='true'>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- react-rating doesn't have types */}
          {React.createElement(Rating as any, {
            readonly: true,
            initialRating: roundedRating,
            emptySymbol: <img src={starEmptySvg} alt='' />,
            fullSymbol: <img src={starFullSvg} alt='' />,
          })}
        </div>
      </span>
      {!!ratingCount && <span aria-hidden>{formatLocaleNumber(ratingCount)}</span>}
      <VisuallyHidden>
        {`Rating: ${roundedRating.toString()} out of 5 stars${
          ratingCount ? ` over ${ratingCount.toString()} reviews` : ''
        }`}
      </VisuallyHidden>
    </div>
  )
})
